import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('users', app)
  return store
}
